import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import StepCard from "./StepCard";

const StepImporting = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.INSURANCE_PLAN);
  const IMPORT = t("IMPORT", { returnObjects: true });

  return (
    <StepCard>
      <div className="pricers-import__loading-container">
        <div className="pricers-import__loading-icon">
          <Spin size="large" />
        </div>
        <h2>{IMPORT.IMPORTING.TITLE}</h2>
        <p className="pricers-import__loading-description">
          {IMPORT.IMPORTING.DESCRIPTION}
        </p>
        <p className="pricers-import__loading-warning">
          {IMPORT.IMPORTING.WARNING}
        </p>
      </div>
    </StepCard>
  );
};

export default StepImporting;
